import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import { BookmarkIcon } from '@heroicons/react/solid';
import noop from 'lodash/noop';
import { generatePath, useNavigate } from 'react-router-dom';

import Button from 'components/buttons/Button';
import { INBOX_PATH } from 'constants/paths';
import { OpportunitiesContext } from 'contexts/OpportunitiesContext/OpportunitiesContext';
import useQueryParams from 'routes/Opportunities/hooks/useQueryParams';

const OpportunitiesListResponseModalRightActions = ({
  onClose = noop,
  opportunity = {},
}) => {
  const navigate = useNavigate();
  const { showDeclined } = useQueryParams();
  const { companiesOpportunitiesOps } = useContext(OpportunitiesContext);
  const { thread } = opportunity;

  if (showDeclined) {
    return (
      <Button
        type="secondary"
        className="space-x-1"
        onClick={() => {
          companiesOpportunitiesOps.undecline(opportunity);
          onClose();
        }}
      >
        <BookmarkIcon className="w-4" /> <span>Reactivate</span>
      </Button>
    );
  }

  if (thread?.exists) {
    return (
      <Button
        onClick={() => {
          navigate(
            generatePath(INBOX_PATH, {
              threadId: thread?.uid,
              tab: thread?.status,
            })
          );
        }}
        data-test-id="opportunity-responseModal-form-submit"
      >
        Go to thread
      </Button>
    );
  }

  return (
    <Button
      onClick={() => {
        companiesOpportunitiesOps.respond(opportunity);
        onClose(false);
      }}
      data-test-id="opportunity-responseModal-form-submit"
    >
      Start conversation
    </Button>
  );
};

OpportunitiesListResponseModalRightActions.propTypes = {
  onClose: PropTypes.func.isRequired,
  opportunity: PropTypes.object.isRequired,
};

export default OpportunitiesListResponseModalRightActions;
